import React from "react";

const NewsCardSkeleton = () => {
  return (
    <div className="bg-white border border-slate-200/60 rounded-lg overflow-hidden animate-pulse">
      <div className="aspect-[16/9] bg-gray-200" />

      <div className="p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="w-16 h-5 bg-gray-200 rounded-full" />
          <div className="w-12 h-4 bg-gray-200 rounded" />
        </div>

        <div className="mb-2">
          <div className="h-4 bg-gray-200 rounded mb-1" />
          <div className="h-4 bg-gray-200 rounded w-3/4" />
        </div>

        <div className="mb-3">
          <div className="h-3 bg-gray-200 rounded mb-1" />
          <div className="h-3 bg-gray-200 rounded mb-1" />
          <div className="h-3 bg-gray-200 rounded w-2/3" />
        </div>

        <div className="flex items-center justify-between">
          <div className="w-20 h-3 bg-gray-200 rounded" />
          <div className="w-16 h-3 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
};

export default NewsCardSkeleton;
